import { render, staticRenderFns } from "./SourcingTable.vue?vue&type=template&id=25a2e83a&scoped=true"
import script from "./SourcingTable.vue?vue&type=script&lang=js"
export * from "./SourcingTable.vue?vue&type=script&lang=js"
import style0 from "./SourcingTable.vue?vue&type=style&index=0&id=25a2e83a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a2e83a",
  null
  
)

export default component.exports